<template>
    <div class="input_native">
        <div v-if="error" class="error__message">{{ message }}</div>
        <input
            v-bind="$attrs"
            :value="value"
            class="input"
            :class="invalid"
            :type="type"
            :placeholder="placeholder"
            v-on="$listeners"
            @input="inputHandle"
        >
    </div>
</template>

<script>
export default {
  props: {
    error: {
      type: Boolean,
    },
    message: {
      type: String,
    },
    type: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    canEdit: {
      type   : Boolean,
      default: true,
    },
    value: {
      type   : String,
      default: '',
    },
  },
  computed: {
    invalid() {
      return this.error ? 'form__error' : '';
    },
  },
  methods: {
    inputHandle(e) {
      if (!this.canEdit) {
        e.target.value = this.value;
      }
    },
  },
};
</script>
